import {
    GET_ARCHIVED_PROJECTS,
    GET_VISIBLE_ARCHIVED_PROJECTS,
    REMOVE_ARCHIVED_PROJECT,
} from '../../actions/types';
import { PostDispatch, ArchivedProjectBrowserModel } from '../../types';

const INITIAL_STATE = new Array<ArchivedProjectBrowserModel>();

const reducer = (
    state = INITIAL_STATE,
    action: PostDispatch
): Array<ArchivedProjectBrowserModel> => {
    switch (action.type) {
        case GET_VISIBLE_ARCHIVED_PROJECTS:
        case GET_ARCHIVED_PROJECTS:
            return action.payload as Array<ArchivedProjectBrowserModel>;
        case REMOVE_ARCHIVED_PROJECT: {
            const { projectId } = action.payload as {
                projectId?: string | null;
            };

            return state.filter((project) => project._id !== projectId);
        }
        default:
            return state;
    }
};
export default reducer;
